import { Module } from "vuex";

import { IRootState } from "@/store";
import { getters } from "@/store/modules/logs/getters";
import { actions } from "@/store/modules/logs/actions";
import { mutations } from "@/store/modules/logs/mutations";
import { ILogsState, state } from "@/store/modules/logs/state";

export const logs: Module<ILogsState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
